// Real AARK projects, grouped by project
// Each project has a cover image and a list of all gallery images.
const rescanyaImages = Array.from({ length: 19 }, (_, i) =>
  `/projects/rescanya-${String(i + 1).padStart(2, "0")}.jpg`
);

export const projects = [
  {
    id: "rescanya",
    cover: "/projects/rescanya-cover.jpg",
    images: rescanyaImages,
  },
  {
    id: "olivereta",
    cover: "/projects/olivereta-01.jpg",
    images: [
      "/projects/olivereta-01.jpg",
      "/projects/olivereta-04.jpg",
      "/projects/olivereta-02.jpg",
      "/projects/olivereta-03.jpg",
      "/projects/olivereta-05.jpg",
    ],
  },
  {
    id: "nou-moles",
    cover: "/projects/nou-moles-01.jpg",
    images: [
      "/projects/nou-moles-01.jpg",
      "/projects/nou-moles-02.jpg",
      "/projects/nou-moles-03.jpg",
      "/projects/nou-moles-04.jpg",
      "/projects/nou-moles-05.jpg",
    ],
  },
  {
    id: "aldaia",
    cover: "/projects/aldaia-01.jpg",
    images: [
      "/projects/aldaia-01.jpg",
      "/projects/aldaia-02.jpg",
      "/projects/aldaia-03.jpg",
      "/projects/aldaia-04.jpg",
      "/projects/aldaia-05.jpg",
    ],
  },
  {
    id: "castellon",
    cover: "/projects/castellon-01.jpg",
    images: [
      "/projects/castellon-01.jpg",
      "/projects/castellon-02.jpg",
      "/projects/castellon-03.jpg",
    ],
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";

export const differentiatorImage =
  "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";
